/**
 * feed reducer
 */
import actionTypes from '../../actions/actionTypes';
import remove from './remove';
import update from './update';
import updatePaginated from './paginated/update';
import removePaginated from './paginated/remove';
import add from './add';

export default function(oldState = {}, action) {
  const isPaginated = !!action.feed && action.feed.isPaginated;
  return isPaginated ?
      reducerPaginatedFeed(oldState, action):
      reducerFeed(oldState, action);
}

export function reducerPaginatedFeed(oldState = {}, action) {
  const { feed = {}, type, dataToDelete } = action;

  switch (type) {
    case actionTypes.LOG_OUT:
    case actionTypes.PROFILE_DELETE:
      return {};
    default:
      break;
  }

  const state = removePaginated(dataToDelete, oldState);

  switch (type) {
    case actionTypes.FEED_INVALIDATE:
    case actionTypes.FEED_RESET:
    case actionTypes.FEED_REQUEST:
    case actionTypes.FEED_REQUEST_FAILURE:
    case actionTypes.FEED_REQUEST_SUCCESS:
      return updatePaginated(feed, action, state);
    default:
      return state;
  }
}

export function reducerFeed(oldState = {}, action) {
  const { feed = {}, type, dataToDelete, data } = action;

  switch (type) {
    case actionTypes.LOG_OUT:
    case actionTypes.PROFILE_DELETE:
      return {};
    default:
      break;
  }

  const state = remove(dataToDelete, oldState);

  switch (type) {
    case actionTypes.MESSAGE_SEND_SUCCESS:
    case actionTypes.POST_SEND_SUCCESS:
      return add(data, state);
    case actionTypes.FEED_INVALIDATE:
    case actionTypes.FEED_RESET:
    case actionTypes.FEED_REQUEST:
    case actionTypes.FEED_REQUEST_FAILURE:
    case actionTypes.FEED_REQUEST_SUCCESS:
      return update(feed, action, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/feeds/index.js